const cart = {
  FreeShippingThreshold:
    "Free shipping on orders of <strong>{{freeShippingThreshold}}</strong> or more",
  EditCart: "Edit cart",
  NewCart: "New cart",
  ViewCart: "View cart",
  GoToCheckout: "Go to checkout",
  item_added: "Item added",
  item_added_plural: "Items added",
  Subtotal: "Subtotal",
  ShippingThresholdHelpText: "Add items and start saving!",
  AwayFromFreeShippingText: "Only <blur><strong>{{amountLeft}}</strong></blur> to go!",
  CongratsYouHaveFreeShipping: "Your shipping is free!",
  CartEmpty: "Your cart is empty",
  FreeShippingThresholdReached: "Your order is {{threshold}} or more.",
  DiscountApplied: "Discount applied at checkout",
  BecomeTaxExempt: "Become tax exempt",
  RemoveCartHeading: "Remove cart?",
  ConfirmDeleteCart: "Are you sure you want to remove this cart?",
  CartDeleteSuccess: "Cart removed successfully",
  CartDeleteFailure: "An error occurred while trying to remove your cart.",
  CartSelected: "Cart selected",
  Practitioners: "(Practitioner's)",
  NoIternalCarts: "You haven't created any internal carts yet",
  NumItems: "{{quantity}} Item",
  NumItems_plural: "{{quantity}} Items",
} as const;

export { cart };
